import { render, staticRenderFns } from "./courseJxsq.vue?vue&type=template&id=eababe20&scoped=true&"
import script from "./courseJxsq.vue?vue&type=script&lang=js&"
export * from "./courseJxsq.vue?vue&type=script&lang=js&"
import style0 from "./courseJxsq.vue?vue&type=style&index=0&id=eababe20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eababe20",
  null
  
)

export default component.exports